<template>
  <v-container>
    <!-- Error Alert -->
    <v-alert
      v-if="error_message"
      type="error"
      dismissible
      @input="error_message = null"
      class="mb-4"
    >
      <v-icon left>mdi-alert-circle</v-icon>
      {{ error_message }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="15"
      item-key="tableName,id"
      sort-by="tableName,id"
      mobile-breakpoint="600"
      class="elevation-1"
      :search="search"
      :loading="loading_status"
      loader-height="5"
      loading-text="Cargando datos..."
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Configuración de Parametrización</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn 
            @click="syncParametrization" 
            color="primary" 
            :loading="loading_status"
            :disabled="loading_status"
          >
            <v-icon left>mdi-sync</v-icon>
            Sincronizar Parametrización
          </v-btn>
          <v-btn 
            @click="loadSettings" 
            color="secondary" 
            class="ml-2"
            :loading="loading_status"
            :disabled="loading_status"
          >
            <v-icon left>mdi-refresh</v-icon>
            Recargar
          </v-btn>
        </v-toolbar>
        
        <!-- Info Panel -->
        <v-card class="ma-2" outlined>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-chip color="primary" small>
                  <v-icon left small>mdi-database</v-icon>
                  {{ items.length }} registros
                </v-chip>
              </v-col>
              <v-col cols="3">
                <v-chip color="info" small>
                  <v-icon left small>mdi-table</v-icon>
                  {{ table_lst.length }} tablas
                </v-chip>
              </v-col>
              <v-col cols="6" v-if="error_message">
                <v-chip color="error" small>
                  <v-icon left small>mdi-alert</v-icon>
                  Error: {{ error_message }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>

    <v-dialog v-model="loading_status" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-6">
          Cargando ...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import createEmpresa from "@/utils/fe_empresa.js";
import { fe_ws } from "@/services/webserver.js";
import createSetting from "@/utils/createSetting.js";

console.log('📦 FE_settings - Component loaded');

export default {
  name: 'FESettings',
  components: {},
  created() {
    console.log('🎬 FE_settings - Component created');
  },
  beforeMount() {
    console.log('📋 FE_settings - Before mount');
  },
  mounted() {
    console.log('🔥 FE_settings - Component mounted');
    console.log('📋 FE_settings - Table list:', this.table_lst.length, 'tables');
    this.loadSettings();
  },
  beforeDestroy() {
    console.log('💀 FE_settings - Before destroy');
  },
  data() {
    console.log('💾 FE_settings - Initializing data');
    return {
      tab: null,
      loading_status: false,
      search: "",
      empresa: createEmpresa(),
      items: [],
      error_message: null,
      headers: [
        {
          text: "Tabla",
          align: "start",
          sortable: true,
          filterable: true,
          value: "tableName",
          dataType: "text",
        },
        {
          text: "ID",
          align: "start",
          sortable: true,
          filterable: true,
          value: "id",
          dataType: "text",
        },
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          filterable: true,
          value: "name",
          dataType: "text",
        },
        {
          text: "Código",
          align: "start",
          sortable: true,
          value: "code",
          dataType: "text",
        },
        {
          text: "Borrado",
          align: "start",
          sortable: true,
          value: "deleted_at",
          dataType: "text",
        },
        {
          text: "Creado",
          align: "start",
          sortable: true,
          value: "created_at",
          dataType: "text",
        },
        {
          text: "Actualizado",
          align: "start",
          sortable: true,
          value: "updated_at",
          dataType: "text",
        },
      ],
      table_lst: [
        "type_documents",
        "taxes",
        "events",
        "countries",
        "languages",
        "discounts",
        "type_times",
        "type_users",
        "tax_details",
        "departments",
        "type_workers",
        "type_regimes",
        "unit_measures",
        "payment_forms",
        "type_coverages",
        "municipalities",
        "type_contracts",
        "type_deliveries",
        "type_currencies",
        "payroll_periods",
        "type_operations",
        "type_principals",
        "payment_methods",
        "subtype_workers",
        "type_liabilities",
        "reference_prices",
        "type_incapacities",
        "type_environments",
        "type_payroll_notes",
        "type_mandate_times",
        "type_organizations",
        "rejection_concepts",
        "type_event_payments",
        "type_scope_mandates",
        "correction_concepts",
        "type_nature_mandates",
        "type_operation_events",
        "type_endorsement_events",
        "type_document_references",
        "organization_provenances",
        "type_item_identifications",
        "type_document_identifications",
        "type_item_sector_identifications",
      ],
      tablas: [],
      settings: createSetting(),
    };
  },
  methods: {
    /**
     * Carga los settings existentes desde la tabla settings
     */
    async loadSettings() {
      console.log('� FE_settings - Cargando settings existentes');
      this.items = [];
      this.error_message = null;
      this.loading_status = true;

      try {
        for (const tableName of this.table_lst) {
          const query = {
            table: "settings",
            filters: [
              {
                field: "tableName",
                operator: "=",
                value: tableName,
              },
            ],
          };

          const result = await this.executeQuery("get_table", query);
          if (result && Array.isArray(result)) {
            this.items.push(...result);
            console.log(`✅ Cargados ${result.length} settings para ${tableName}`);
          }
        }
        
        console.log(`🏁 Total settings cargados: ${this.items.length}`);
      } catch (error) {
        console.error('❌ Error cargando settings:', error);
        this.error_message = `Error cargando settings: ${error.message}`;
      } finally {
        this.loading_status = false;
      }
    },

    /**
     * Sincroniza la parametrización descargando desde la API y actualizando la tabla
     */
    async syncParametrization() {
      console.log('🔄 FE_settings - Iniciando sincronización de parametrización');
      this.error_message = null;
      this.loading_status = true;

      try {
        let totalSynced = 0;
        
        for (const tableName of this.table_lst) {
          console.log(`🔄 Sincronizando tabla: ${tableName}`);
          
          const query = { tables: tableName };
          const result = await this.executeQuery("get_listings", query);
          
          if (result) {
            const data = JSON.parse(result);
            const tableData = data[tableName];
            
            if (tableData && Array.isArray(tableData)) {
              // Agregar tableName a cada registro
              tableData.forEach(record => {
                record.tableName = tableName;
              });
              
              // Insertar en la tabla settings
              await this.insertToSettings(tableData);
              totalSynced += tableData.length;
              
              console.log(`✅ Sincronizados ${tableData.length} registros para ${tableName}`);
            }
          }
        }
        
        console.log(`🎉 Sincronización completada: ${totalSynced} registros actualizados`);
        
        // Recargar los settings para mostrar los datos actualizados
        await this.loadSettings();
        
      } catch (error) {
        console.error('❌ Error en sincronización:', error);
        this.error_message = `Error en sincronización: ${error.message}`;
      } finally {
        this.loading_status = false;
      }
    },

    /**
     * Ejecuta una consulta usando fe_ws con manejo de promesas
     */
    executeQuery(method, data) {
      return new Promise((resolve, reject) => {
        fe_ws(
          method,
          data,
          (response) => {
            console.log(`✅ ${method} exitoso:`, response);
            resolve(response);
          },
          (error) => {
            console.error(`❌ ${method} falló:`, error);
            reject(error);
          }
        );
      });
    },

    /**
     * Inserta datos en la tabla settings
     */
    async insertToSettings(data) {
      console.log('💾 Insertando datos en settings:', data.length, 'registros');
      
      const query = {
        table: "settings",
        data: data,
      };
      
      return this.executeQuery("put_to_table", query);
    },
  },
};
</script>

<style scoped>
.v-data-table {
  font-size: 0.875rem;
}

.v-chip {
  font-size: 0.75rem;
}

.v-toolbar-title {
  font-weight: 500;
}
</style>
